export const isValidString = (string) => typeof string === 'string' && string.trim().length > 0;

export const isValidObject = (object) => typeof object === 'object' && object !== null;

export const isValidObjectButNotArray = (object) => (
  typeof object === 'object' && object !== null && !Array.isArray(object)
);

export const getIn = (object, keyArray) => {
  if (!keyArray.every((key) => (
    typeof key === 'string'
    || typeof key === 'number'
    || typeof key === 'boolean'
  ))) {
    throw new TypeError('Expected keys to be strings, numbers, or booleans.');
  }

  return keyArray.reduce((anObject, key) => {
    if (!isValidObject(anObject)) {
      return undefined;
    }

    return anObject[key];
  }, object);
};

export const setIn = (object, keyArray, value) => {
  const keysExceptLast = keyArray.slice(0, -1);

  const finalObject = keysExceptLast.reduce((anObject, key) => {
    if (anObject[key] === undefined || anObject[key] === null) {
      // eslint-disable-next-line no-param-reassign -- TODO: Replace
      anObject[key] = {};
    } else if (!isValidObject(anObject[key])) {
      throw new Error('Unwilling to overwrite value with an empty object.');
    }

    return anObject[key];
  }, object);

  finalObject[keyArray[keyArray.length - 1]] = value;
};

export const objectValuesSortedByKey = (object) => (
  Object.keys(object).sort().map((key) => object[key])
);
